import { Drawer, DrawerContent, DrawerBody, DrawerHeader, CloseButton, HStack, Heading } from '@chakra-ui/react'
import React from 'react';

export const CourseReviewSidebar = (props: {
  label: string;
  allowPin: boolean;
  isOpen: boolean;
  size?: 'xs' | 'sm' | 'md';
  onClose: () => void;
  children?: React.ReactNode;
}) => {

  return (
    <Drawer
      variant={props.allowPin ? 'alwaysOpen' : ''}
      placement='left'
      onClose={props.onClose}
      isOpen={props.isOpen}
      size={props.size || 'md'}
      blockScrollOnMount={false}
      trapFocus={false}>
      <DrawerContent className="no-print" marginTop={120} p='0'>
        <DrawerHeader>
          <HStack justify='space-between'>
            <Heading size='sm'>{props.label}</Heading>
            <CloseButton onClick={props.onClose} />
          </HStack>
        </DrawerHeader>
        <DrawerBody p='0!important'>
          {props.children}
        </DrawerBody>
      </DrawerContent>
    </Drawer >
  )
}